import { Route } from '@angular/router';
import { CurrenciesResolver, FuelPreferenceResolver, UnitsResolver } from "../../../../../common/routing";
import { TenderBidsComponent } from '../../../../pages';
import { SealedTenderGuard } from '../../../guards/sealed-tender.guard';
import {
  TenderContractsStatisticResolver
} from '../../../resolvers';
import { contractsAllRoute } from "./contract/children";
import { contractsAwaitingBidsRoute } from "./contract/children/awaiting-bids";
import { contractsAwaitingReviewRoute } from "./contract/children/awaiting-review";
import { contractsAwardedRoute } from "./contract/children/awarded";
import { contractsCancelledRoute } from "./contract/children/cancelled";
import { contractsExpiredRoute } from "./contract/children/expired";


export const tenderContractsRoute: Route = {
    path: 'locations',
    component: TenderBidsComponent,
    resolve: {
        stats: TenderContractsStatisticResolver,
        currenciesCollection: CurrenciesResolver,
        unitsCollection: UnitsResolver,
        fuelPreferenceCollection: FuelPreferenceResolver,
    },
    canActivate: [SealedTenderGuard],
    children: [
        {
            path: '',
            redirectTo: 'all',
            pathMatch: 'full',
        },
        contractsAllRoute,
        contractsAwaitingBidsRoute,
        contractsAwaitingReviewRoute,
        contractsCancelledRoute,
        contractsExpiredRoute,
        contractsAwardedRoute
    ]
};
